import { CardContainer } from "../../../components/Card/CardContainer";
import React, { useCallback, useEffect, useState } from "react";
import Swal from "sweetalert2";
import PageTitleNested from "../../../components/PageTitle/PageTitleNested";
import { Col, Form, Radio, Row, Space } from "antd";
import ProfileImage from "../../../components/ProfileImage/ProfileImage";
import Button from "../../../components/Button/Button";
import Input from "../../../components/Input/Input";
import { defaultPropsFormRequire } from "../../../utility/DefaultProps";
import Select from "../../../components/Select/Select";
import styled from "styled-components";
import color from "../../../resource/color";
import Text from "../../../components/Text/Text";
import { useNavigate, useParams } from "react-router-dom";
import { SaleListDatasource } from "../../../datasource/SaleListDatasource";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import { useRecoilValue } from "recoil";
import { profileAtom } from "../../../store/ProfileAtom";
import { zoneDatasource } from "../../../datasource/ZoneDatasource";
import { roleDatasource } from "../../../datasource/RoleDatasource";
import { useLocalStorage } from "../../../hook/useLocalStorage";
import { checkCompany } from "../../../utility/CompanyName";
import UploadImageCropper from "../../../components/UploadFile/UploadImageCropper";
import { teamDatasource } from "../../../datasource/TeamDatasource";
import { formatUserTeams } from "../../../definitions/formatUsersTeam";
import { Texts } from "./SaleManagementPage";
import { filterUserStaffToTeam } from "../../../utility/filterUserStaffToTeam";

type DeletePayload = {
  userStaffId: string;
  userStaffToTeamId: string[];
  zone: string[];
};
const Top = styled.div``;
const Bottom = styled(Row)`
  border-top: 1px solid ${color.background2};
  padding-top: 20px;
  margin-top: 64px;
`;

export function EditUserSale() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [visibleWarning, setVisibleWarning] = React.useState(false);
  const profile = useRecoilValue(profileAtom);
  const { userStaffId } = useParams();
  const [company] = useLocalStorage("profile", null);
  const isInternal = checkCompany(company.company);
  const [roleList, setRoleList] = React.useState<{ label: string; value: string; key: string }[]>(
    [],
  );
  const [deleteTeamZone, setDeleteTeamZone] = useState<DeletePayload>();
  const [teamId, setTeamId] = useState<string[]>([]);
  const selectedRole = Form.useWatch("role", form);
  const [file, setFile] = useState<File | null>(null);
  const [roleData, setRoleData] = React.useState<any[]>([]);
  const { setFieldsValue } = form;
  const [zone, setZone] = React.useState<{ label: string; value: string; key: string }[]>([]);
  const [team, setTeam] = React.useState<{ label: string; value: string; key: string }[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [visible, setVisible] = React.useState(false);
  const [selectTeam, setSelectTeam] = useState<string | undefined>(undefined);
  const [selectZone, setSelectZone] = useState<string | undefined>(undefined);
  const [additionalRoles, setAdditionalRoles] = useState<string>("");
  const [additionalSetting, setAdditionalSetting] = useState<string>("");
  const [userStaffToTeam, setUserStaffToTeam] = useState<any>();
  const [removeZone, setRemoveZone] = useState<string[]>([]);

  const getTeam = async () => {
    const res = await zoneDatasource.getAllTeam({
      page: 0,
      take: 0,
      company: company?.company,
      status: "ACTIVE",
    });
    const data = res?.data.map((item: any) => {
      return {
        label: item.teamName,
        value: item.teamName,
        key: item.teamId,
      };
    });
    setTeam(data);
    const allZone = form.getFieldValue("isAllZone");
    const allTeam = form.getFieldValue("isAllTeam");

    if (additionalRoles === "MULTI_ZONE") {
      const isAllTeams = allTeam === "ALL";
      const isAllZones = allZone === "ALL";
      const isCustomZones = allZone === "CUSTOM";

      if ((isAllZones && isAllTeams) || (isCustomZones && isAllTeams)) {
        getZone(data.map((e) => e.key));
      } else {
        getZone(teamId);
      }
    } else if (additionalRoles === "SINGLE_ZONE") {
      getZone(teamId);
    }
  };

  const getZone = async (id: string | string[]) => {
    const incomingIds = Array.isArray(id) ? id : [id];
    const oldTeamIds = userStaffToTeam?.map((item) => item.teamId) || [];
    const custom_team = form.getFieldValue("isAllTeam");
    const combinedTeamIds =
      custom_team === "CUSTOM"
        ? [...incomingIds]
        : Array.from(new Set([...oldTeamIds, ...incomingIds]));
    const payload = {
      teamId: additionalRoles === "SINGLE_ZONE" ? incomingIds : combinedTeamIds,
    };
    try {
      await teamDatasource.multiTeamZone(payload).then((res) => {
        const data = res?.map((item: any) => {
          return {
            label: item.zoneName,
            value: item.zoneName,
            key: item.zoneId,
          };
        });
        if (data?.length === 0) {
          form.setFieldValue("zone", undefined);
          setZone([]);
        } else {
          setZone(data);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getTeamWithZone = async (id: string, userTeamToId?: string[]) => {
    try {
      const zoneRes = await zoneDatasource.getAllZoneByTeam(id);
      const zoneData = zoneRes?.zone.map((item: any) => ({
        label: item.zoneName,
        value: item.zoneName,
        key: item.zoneId,
      }));

      const matchedZones = zoneData?.filter((zone) => removeZone.includes(zone.value)) || [];
      const onlyValues = matchedZones.map((zone) => zone.value);

      if (userStaffId && selectTeam === "CUSTOM") {
        deleteTeamAndZone(userStaffId, userTeamToId, onlyValues);
      }

      const zoneObjects = onlyValues
        .map((value) => {
          if (additionalRoles !== "MULTI_ZONE") {
            form.setFieldsValue({ zone: value });
          }
          return zoneData.find((zone) => zone.value === value);
        })
        .filter(Boolean);
      setZone(zoneObjects);
    } catch (error) {
      console.error("Error find team with zone:", error);
    }
  };
  const getRoleList = async () => {
    const { data } = await roleDatasource.getAllRoles({
      page: 1,
      take: 100,
      company: profile?.company,
    });
    setRoleData(data?.data || []);
    const newFormat = data.data.map((el: { rolename: string; roleId: string }) => {
      return {
        label: el.rolename,
        value: el.rolename,
        key: el.roleId,
      };
    });
    setRoleList(newFormat);
  };
  const handleRoleChange = (role) => {
    const isRole = roleData?.find((item) => item.rolename === role);
    const isMultiZone = isRole?.additionalroles === "MULTI_ZONE";
    const resetFields = {
      zone: undefined,
      userStaffToTeam: undefined,
      docType: undefined,
      team: undefined,
      isAllTeam: isMultiZone ? "ALL" : "CUSTOM",
      isAllZone: isMultiZone ? "ALL" : "CUSTOM",
    };
    setSelectTeam(isMultiZone ? "ALL" : "CUSTOM");
    setSelectZone(isMultiZone ? "ALL" : "CUSTOM");
    setFieldsValue(resetFields);

    if (isMultiZone) {
      getTeam();
    }
  };

  const getInitialValue = useCallback(async () => {
    try {
      const result = await SaleListDatasource.getSaleStaffById(userStaffId);
      const { fullTeamList, teamNames } = formatUserTeams(result.userStaffToTeam);
      setRemoveZone(result.zone);
      setSelectTeam(result.isAllTeam);
      setSelectZone(result.isAllZone);
      setTeamId(fullTeamList.map((val) => val.key));
      setUserStaffToTeam(result.userStaffToTeam);
      form.setFieldsValue({
        ...result,
        profileImage: { base64: result.profileImage, file: null },
        userStaffToTeam: result.isAllTeam === "ALL" ? [] : teamNames,
        isAllTeam: result.isAllTeam,
        isAllZone: result.isAllZone,
        zone: result.isAllZone === "ALL" ? [] : result.zone,
      });
    } catch (error) {
      console.error("Failed to fetch staff data:", error);
    }
  }, [form, userStaffId]);

  useEffect(() => {
    getInitialValue();
  }, [userStaffId]);

  useEffect(() => {
    const role = roleData?.find((item) => item.rolename === selectedRole);
    setAdditionalSetting(role?.additionalSetting || null);
    setAdditionalRoles(role?.additionalroles || null);
  }, [selectedRole, roleData]);

  useEffect(() => {
    getRoleList();
    getTeam();
  }, [additionalRoles]);

  const getUserStaffToTeam = (
    additionalRoles: string,
    selectTeam: string,
    team?: { key: string }[],
    teamId?: string[],
  ) => {
    if (additionalRoles === "MULTI_ZONE" && selectTeam === "ALL" && Array.isArray(team)) {
      return team.map((t) => ({ teamId: t.key }));
    }

    if ((additionalRoles === "MULTI_ZONE" || additionalRoles === "SINGLE_ZONE") && teamId) {
      const ids = Array.isArray(teamId) ? teamId : [teamId];
      return ids.map((id) => ({ teamId: id }));
    }

    return [];
  };
  const newUserStaffToTeams = getUserStaffToTeam(additionalRoles, selectTeam!, team, teamId);

  const deleteTeamAndZone = (
    userStaffId: string,
    selectedTeamIds: string[] = [],
    selectedZoneIds: string[] = [],
  ) => {
    let deletedTeamIds: any;
    let deletedZoneIds: any;
    if (selectedTeamIds.length > 0) {
      deletedTeamIds = userStaffToTeam.filter((teamId) => !selectedTeamIds.includes(teamId));
      deletedZoneIds = Array.isArray(removeZone)
        ? removeZone.filter((zoneId) => !selectedZoneIds.includes(zoneId))
        : [];
    }
    if (selectedZoneIds.length > 0) {
      deletedZoneIds = Array.isArray(removeZone)
        ? removeZone.filter((zoneId) => !selectedZoneIds.includes(zoneId))
        : [];
    }

    const payload: DeletePayload = {
      userStaffId,
      userStaffToTeamId: Array.isArray(deletedTeamIds)
        ? deletedTeamIds.map((x) => x.userStaffToTeamId)
        : deletedTeamIds?.userStaffToTeamId
          ? [deletedTeamIds.userStaffToTeamId]
          : [],
      zone: deletedZoneIds || [],
    };

    setDeleteTeamZone(payload);
    const mappedUserStaffToTeam = filterUserStaffToTeam(userStaffToTeam, payload.userStaffToTeamId);
    const existingTeamIds = mappedUserStaffToTeam.map((item) => item.teamId);
    if (selectedTeamIds.length > 0) {
      getZone(existingTeamIds);
    }
  };
  const handleUpload = (uploadedFile: File | null) => {
    setFile(uploadedFile);
    form.setFieldValue("signImage", uploadedFile);
  };

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      if (userStaffId) {
        values.userStaffId = userStaffId;
      }
      if (values.profileImage) {
        if (values.profileImage.file) {
          const data = new FormData();
          data.append("userStaffId", userStaffId || "");
          data.append("profileImage", values.profileImage.file);
          await SaleListDatasource.uploadProfile(data);
        }
      } else {
        const data = new FormData();
        data.append("userStaffId", userStaffId || "");
        await SaleListDatasource.uploadProfile(data);
      }
      if (!["MULTI_ZONE", "SINGLE_ZONE"].includes(additionalRoles)) {
        const userStaffId = userStaffToTeam[0]?.userStaffId ?? null;
        const result = {
          userStaffId,
          userStaffToTeamId: userStaffToTeam.map((item) => item.userStaffToTeamId),
          zone: removeZone,
        };
        if (result.userStaffToTeamId.length > 0) {
          try {
            await teamDatasource.deleteUserTeamZone(result);
          } catch (error) {
            console.log("error deleting user team zone (custom case)", error);
          }
        }
      }
      if (deleteTeamZone) {
        try {
          await teamDatasource.deleteUserTeamZone(deleteTeamZone);
        } catch (error) {
          console.log("delete user staff team and zone", error);
        }
      }
      const { team, ...restValues } = values;
      const zoneValues =
        additionalRoles === "MULTI_ZONE" && selectZone === "ALL"
          ? zone.map((val) => val.value)
          : values.zone;

      const zoneString = Array.isArray(zoneValues)
        ? zoneValues.join(",")
        : typeof zoneValues === "string"
          ? zoneValues
          : "";

      const mappedUserStaffToTeam = filterUserStaffToTeam(
        userStaffToTeam,
        (deleteTeamZone?.userStaffToTeamId || []).filter((id): id is string => id !== null),
      );
      const existingTeamIds = new Set(mappedUserStaffToTeam.map((item) => item.teamId));
      const additionalTeams = newUserStaffToTeams
        .filter((item) => !existingTeamIds.has(item.teamId))
        .map((item) => ({ teamId: item.teamId, userStaffId: userStaffId }));
      const getFinalUserStaffToTeam = (): { teamId: string }[] => {
        const newTeam = additionalTeams;
        switch (additionalRoles) {
          case "MULTI_ZONE": {
            const combinedTeams = [...mappedUserStaffToTeam, ...newTeam];
            const uniqueTeams = Array.from(
              new Map(combinedTeams.map((team) => [team.teamId, team])).values(),
            );
            return uniqueTeams;
          }
          case "SINGLE_ZONE": {
            const newTeamWithIds = newTeam.map((newItem) => {
              const matchedOld = mappedUserStaffToTeam.find(
                (oldItem) => oldItem.userStaffId === newItem.userStaffId,
              );
              return matchedOld
                ? { ...newItem, userStaffToTeamId: matchedOld.userStaffToTeamId }
                : newItem;
            });
            return newTeamWithIds;
          }

          default:
            return [];
        }
      };

      const updatedValues = {
        ...restValues,
        zone: ["MULTI_ZONE", "SINGLE_ZONE"].includes(additionalRoles) ? zoneString : "null",
        updateBy: `${profile?.firstname} ${profile?.lastname}`,
        signImage: undefined,
        isAllTeam: selectTeam,
        isAllZone: selectZone,
        userStaffToTeam: ["MULTI_ZONE", "SINGLE_ZONE"].includes(additionalRoles)
          ? JSON.stringify(getFinalUserStaffToTeam())
          : "null",
      };
      let res: any;

      if (file) {
        res = await SaleListDatasource.updateUserStaff(userStaffId || "", updatedValues);
        if (res.success) {
          const uploadFile = await SaleListDatasource.uploadSignImage(userStaffId!, file);
          if (uploadFile && uploadFile.success) {
            Swal.fire({
              title: "บันทึกข้อมูลสำเร็จ",
              text: "",
              width: 250,
              icon: "success",
              timer: 2000,
              customClass: {
                title: "custom-title",
              },
              showConfirmButton: false,
            }).then(() => {
              setLoading(false);
              navigate(-1);
            });
          }
        }
      } else {
        if (restValues?.signImage === null) {
          await SaleListDatasource.deleteSignImage(userStaffId!);
        }
        const res = await SaleListDatasource.updateUserStaff(userStaffId || "", updatedValues);

        if (res && res.success) {
          Swal.fire({
            title: "บันทึกข้อมูลสำเร็จ",
            text: "",
            width: 250,
            icon: "success",
            timer: 2000,
            customClass: {
              title: "custom-title",
            },
            showConfirmButton: false,
          }).then(() => {
            setLoading(false);
            navigate(-1);
          });
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CardContainer>
      <Form
        {...defaultPropsFormRequire}
        form={form}
        onFinish={onFinish}
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <Top>
          <PageTitleNested
            title='แก้ไขรายชื่อผู้ใช้งาน'
            cutParams
            onBack={() => {
              const isHaveValue = Object.values(form.getFieldsValue()).some((item) => item);
              if (isHaveValue) {
                setVisibleWarning(true);
              } else {
                navigate(-1);
              }
            }}
          />
          <Row>
            <Form.Item name='profileImage'>
              <ProfileImage />
            </Form.Item>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name='firstname'
                label='ชื่อ'
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกชื่อ",
                  },
                ]}
              >
                <Input placeholder='ระบุชื่อ' autoComplete='off' />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name='lastname'
                label='นามสกุล'
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกนามสกุล",
                  },
                ]}
              >
                <Input placeholder='ระบุนามสกุล' autoComplete='off' />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name='nickname' label='ชื่อเล่น'>
                <Input placeholder='ระบุชื่อเล่น' autoComplete='off' />
              </Form.Item>
            </Col>
            {isInternal && (
              <Col span={12}>
                <Form.Item name='userNav' label='ชื่อผู้ใช้ Navision'>
                  <Input placeholder='ระบุชื่อผู้ใช้' autoComplete='off' />
                </Form.Item>
              </Col>
            )}
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name='telephone'
                label='เบอร์โทรศัพท์'
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกเบอร์โทรศัพท์",
                  },
                  {
                    pattern: /^[0-9]*$/,
                    message: "กรุณากรอกเบอร์โทรศัพท์เป็นตัวเลขเท่านั้น",
                  },
                  {
                    min: 10,
                    message: "กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก",
                  },
                ]}
              >
                <Input placeholder='ระบุเบอร์โทรศัพท์' maxLength={10} autoComplete='off' />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name='email'
                label='อีเมล'
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกอีเมล",
                  },
                  {
                    type: "email",
                    message: "กรุณากรอกอีเมลให้ถูกต้อง",
                  },
                ]}
              >
                <Input disabled placeholder='ตัวอย่าง iconkaset.i@iconkaset.com' />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={additionalSetting === "NAV_DOC" ? 12 : 24}>
              <Form.Item
                name='role'
                label='บทบาท'
                rules={[
                  {
                    required: true,
                    message: "กรุณาเลือกบทบาท",
                  },
                ]}
              >
                <Select
                  style={{ marginBottom: 10 }}
                  data={roleList}
                  placeholder='เลือกบทบาท'
                  onChange={(selectedRole) => handleRoleChange(selectedRole)}
                />
              </Form.Item>
            </Col>
            <Form.Item
              noStyle
              shouldUpdate={(prev, current) => {
                return prev.role !== current.role;
              }}
            >
              {({ getFieldValue }) => {
                return (
                  <>
                    {additionalSetting === "NAV_DOC" && (
                      <Col span={12}>
                        <Form.Item label='ประเภทเอกสาร Navision' name={"docType"}>
                          <Select
                            data={[
                              {
                                label: "SO (Sales Order CO-Sale)",
                                value: "Co-Sales",
                                key: "Co-Sales",
                              },
                              {
                                label: "SP (Sales Order Inventory)",
                                value: "Inventory",
                                key: "Inventory",
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                    )}
                  </>
                );
              }}
            </Form.Item>
          </Row>
          {additionalRoles === "SINGLE_ZONE" && (
            <>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name='userStaffToTeam' label='ทีม'>
                    <Select
                      style={{ width: "100%" }}
                      placeholder='ระบุทีม'
                      data={team}
                      onChange={(values) => {
                        const selectedTeamIds = team
                          .filter((item) => values.includes(item.value))
                          .map((item) => item.key);
                        setTeamId(selectedTeamIds);
                        getZone(selectedTeamIds);
                        form.setFieldValue("zone", undefined);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name='zone'
                    label='เขต'
                    rules={[
                      {
                        required: true,
                        message: "กรุณาเลือกเขต",
                      },
                    ]}
                  >
                    <Select style={{ marginBottom: 8 }} data={zone} placeholder='ระบุเขต' />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          {additionalRoles === "MULTI_ZONE" && (
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name='isAllTeam' label='ทีม' initialValue='ALL'>
                  <Row gutter={8} align='middle'>
                    <Col span={8}>
                      <Radio.Group
                        value={selectTeam}
                        onChange={(e) => {
                          setSelectTeam(e.target.value);
                          form.setFieldValue("zone", undefined);
                          if (e.target.value === "ALL") {
                            form.setFieldValue("userStaffToTeam", undefined);
                            const oldTeamIds = userStaffToTeam?.map((item) => item.teamId) || [];
                            getZone(oldTeamIds);
                            getTeam();
                          }
                        }}
                        style={{ width: "100%" }}
                      >
                        <Space>
                          <Radio value='ALL'>
                            <Texts>ทั้งหมด</Texts>
                          </Radio>
                          <Radio value='CUSTOM'>
                            <Texts>เลือกทีม</Texts>
                          </Radio>
                        </Space>
                      </Radio.Group>
                    </Col>

                    <Col span={16}>
                      <Form.Item name='userStaffToTeam' noStyle>
                        <Select
                          disabled={selectTeam !== "CUSTOM"}
                          placeholder='ระบุทีม'
                          style={{ width: "100%" }}
                          mode='multiple'
                          data={team}
                          onChange={(values) => {
                            const selectedTeamIds = team
                              .filter((item) => values.includes(item.value))
                              .map((item) => item.key);
                            setTeamId(selectedTeamIds);
                            const userStaffToTeamIds = userStaffToTeam.filter((item) =>
                              selectedTeamIds.includes(item.teamId),
                            );

                            if (userStaffId && selectTeam === "CUSTOM") {
                              deleteTeamAndZone(userStaffId, userStaffToTeamIds, removeZone);
                            }
                            getZone(selectedTeamIds);
                            if (removeZone && selectZone !== "CUSTOM") {
                              selectedTeamIds.forEach((teamId) => {
                                getTeamWithZone(teamId, userStaffToTeamIds);
                              });
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name='isAllZone'
                  label='เขต'
                  initialValue='ALL'
                  rules={[{ required: true, message: "กรุณาเลือกเขต" }]}
                >
                  <Row gutter={8} align='middle'>
                    <Col span={8}>
                      <Radio.Group
                        value={selectZone}
                        onChange={(e) => {
                          const value = e.target.value;
                          setSelectZone(value);
                          getTeam();
                          if (value === "ALL") {
                            form.setFieldValue("zone", undefined);
                            getZone(teamId);
                          } else if (value === "CUSTOM") {
                            form.setFieldValue("zone", undefined);
                            if (teamId && teamId.length > 0) {
                              getZone(teamId);
                            } else {
                              form.setFieldValue("zone", undefined);
                              getZone([]);
                            }
                          }
                        }}
                        style={{ width: "100%" }}
                      >
                        <Space>
                          <Radio value='ALL'>
                            <Texts>ทั้งหมด</Texts>
                          </Radio>
                          <Radio value='CUSTOM'>
                            <Texts>เลือกเขต</Texts>
                          </Radio>
                        </Space>
                      </Radio.Group>
                    </Col>

                    <Col span={16}>
                      <Form.Item
                        name='zone'
                        noStyle
                        rules={[
                          {
                            required: selectZone === "CUSTOM",
                            message: "กรุณาเลือกเขต",
                          },
                        ]}
                      >
                        <Select
                          disabled={selectZone !== "CUSTOM"}
                          placeholder='ระบุเขต'
                          style={{ width: "100%" }}
                          mode='multiple'
                          data={zone}
                          onChange={(selectedZoneIds) => {
                            if (userStaffId && selectZone === "CUSTOM") {
                              const currentZoneValues = form.getFieldValue("zone") || [];
                              const userStaffToTeamIds = userStaffToTeam.filter((item) =>
                                teamId.includes(item.teamId),
                              );
                              deleteTeamAndZone(userStaffId, userStaffToTeamIds, currentZoneValues);
                              form.setFieldsValue({
                                zone: selectedZoneIds,
                              });
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row gutter={16}>
            <Col span={12} style={{ marginTop: 18 }}>
              <Text fontSize={16} fontWeight={700}>
                ไฟล์ลายเซ็นต์
              </Text>
              <br />
              <Text fontSize={14} fontWeight={400} color='grayishBlue' fontFamily='Sarabun'>
                โปรดเลือกไฟล์รูปภาพลายเซ็นต์ที่ต้องการ (ขนาดภาพที่แนะนำ 400*140 px, ไฟล์ .PNG)
              </Text>
              <Form.Item name='signImage'>
                <UploadImageCropper
                  onFileUpload={handleUpload}
                  value={file}
                  accept='image'
                  aspect={1}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name='status' label='สถานะ*'>
                <Radio.Group style={{ fontFamily: "IBM Plex Sans Thai" }}>
                  <Space direction='vertical'>
                    <Radio value='ACTIVE'>เปิดใช้งาน</Radio>
                    <Radio value='INACTIVE'>ปิดใช้งาน</Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Top>
        <Bottom>
          <Col span={22}>
            <Text color='Text3' level={6} fontFamily='Sarabun'>
              โปรดตรวจสอบข้อมูลพนักงานก่อนบันทึก
            </Text>
          </Col>
          <Col span={2}>
            <Button
              title='บันทึก'
              onClick={() => {
                setVisible(true);
              }}
            />
          </Col>
        </Bottom>
      </Form>
      <ConfirmModal
        visible={visible}
        loading={loading}
        onConfirm={() => {
          form.submit();
          setVisible(false);
        }}
        onCancel={() => {
          setVisible(false);
        }}
        title='ยืนยันการบันทึกข้อมูล'
        desc='โปรดยืนยันการบันทึกข้อมูลเพิ่มตำแหน่งชื่อ'
      />
      <ConfirmModal
        visible={visibleWarning}
        onConfirm={() => {
          setVisibleWarning(false);
          navigate(-1);
        }}
        onCancel={() => {
          setVisibleWarning(false);
        }}
        title='คุณต้องการกลับสู่หน้าหลักใช่หรือไม่'
        desc='โปรดยืนยันการกลับสู่หน้าหลัก'
      />
    </CardContainer>
  );
}
